<template>
  <svg 
    aria-hidden="true"
    focusable="false"
    data-icon="file-document"
    role="img"
    viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '$vuetify.icons.file-document',
    },
  },
};
</script>